import { GetPathAndParam } from 'components/hmilib/hmiclientbase';
import {
    ErrorResponse,
    ExportHistoryRequest,
    ExportReadProcessedRequest,
    ReadAtTimeRequest,
    ReadProcessedRequest,
    ReadProcessedResponse,
    ReadRawRequest,
    ReadRowResponse,
    UpdateTagsRequest
} from 'components/hmilib/interfaces';
import { fetchData } from './index';

export const UpdateTags = (tags: Array<UpdateTagsRequest>): Promise<boolean> => {
    return fetchData('/Tags/UpdateTags', 'POST', tags)
        .then(() => true)
        .catch((error) => {
            console.error('Error:', error);
            throw error;
        });
};

export const ReadRaw = (
    Items: Array<string>,
    startTimeIso: string,
    endTimeIso: string,
    limit: number = 0,
    getBounds: number = 0
): Promise<Array<ReadRowResponse>> => {
    const body: ReadRawRequest = {
        begin: startTimeIso,
        end: endTimeIso,
        limit,
        getBounds,
        ids: Items.map((item) => {
            const { path } = GetPathAndParam(item);
            return `${path}`;
        })
    };

    return fetchData('/Tags/ReadRaw', 'POST', body)
        .then((response) => {
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            throw error;
        });
};

export const ReadAtTime = (
    Items: Array<string>,
    TimeArray: Array<number | string>
): Promise<Array<ReadRowResponse> | ErrorResponse> => {
    const body: ReadAtTimeRequest = {
        ids: Items.map((item) => {
            const { path } = GetPathAndParam(item);
            return `${path}`;
        }),
        TimeArray
    };

    return fetchData('/Tags/ReadAtTime', 'POST', body)
        .then((response) => {
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            throw error;
        });
};

export const ReadProcessed = (
    ids: Array<string>,
    aggregateType: Array<string>,
    begin: string,
    end: string,
    ProcessingInterval: number
): Promise<ReadProcessedResponse | ErrorResponse> => {
    const body: ReadProcessedRequest = {
        ids: ids.map((id) => {
            const { path } = GetPathAndParam(id);
            return `${path}`;
        }),
        aggregateType,
        begin,
        end,
        ProcessingInterval
    };

    return fetchData('/Tags/ReadProcessed', 'POST', body)
        .then((response) => {
            return response.json();
        })
        .then((tempjson) => {
            return tempjson.Items.map((item: any) => ({ ...item, T: tempjson.T }));
        })
        .catch((error) => {
            console.error('error', error);
            throw error;
        });
};

export const ExportHistoryRaw = (
    ids: Array<string>,
    startTimeIso: string,
    endTimeIso: string,
    limit: number = 0,
    getBounds: number = 0,
    delimiter: string = ','
): Promise<Blob> => {
    const processedIds = ids.map((id) => {
        const item = GetPathAndParam(id);
        return `${item.path}`;
    });

    const requestBody: ExportHistoryRequest = {
        items: {
            ids: processedIds,
            begin: startTimeIso,
            end: endTimeIso,
            limit,
            getBounds
        },
        delimiter,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    return fetchData('/Tags/ExportHistoryRaw', 'POST', requestBody)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.blob();
        })
        .catch((error) => {
            console.error('error', error);
            throw error;
        });
};

export const ExportReadProcessed = (
    ids: Array<string>,
    aggregateTypes: Array<string>,
    startTimeIso: string,
    endTimeIso: string,
    processingInterval: number = 0,
    delimiter: string = ','
): Promise<Blob> => {
    const processedIds = ids.map((id) => {
        const item = GetPathAndParam(id);
        return `${item.path}`;
    });

    const requestBody: ExportReadProcessedRequest = {
        items: {
            ids: processedIds,
            aggregateType: aggregateTypes,
            begin: startTimeIso,
            end: endTimeIso,
            ProcessingInterval: processingInterval
        },
        delimiter,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    return fetchData('/Tags/ExportReadProcessed', 'POST', requestBody)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.blob();
        })
        .catch((error) => {
            console.error('error', error);
            throw error;
        });
};
